// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"building"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M16 6H19V10H20V21H4V10H5V6H8V3H16V6Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M9 15V21H15V15H9Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M9 15V21H15V15H9Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M16 6V3H8V6M16 6H19V10M16 6H8M8 6H5V10M19 10H5M19 10H20M5 10H4M4 10V21M4 10H3M4 21H3M4 21H20M20 10V21M20 10H21M20 21H21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const BuildingIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'building',
    ref,
    icon: element,
  },
));

BuildingIcon.displayName = 'BuildingIcon';

export default BuildingIcon;
